import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";

var SvgWes = function SvgWes(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 390 390"
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M257.4 300l39.2-28c5.3-3.8 8.4-9.8 8.4-16.3V129c0-8.6-5.5-16.3-13.7-19-1.1-.4-2.3-.8-3.5-1.1l-5.7-38.3c-1.4-9.1-8-16.6-17-18.9-14.9-3.8-39.8-8.7-70.1-8.7s-55.3 4.9-70.1 8.7c-9 2.3-15.6 9.8-17 18.9l-5.7 38.3c-1.2.4-2.4.8-3.5 1.1-8.2 2.7-13.7 10.4-13.7 19v126.7c0 6.5 3.1 12.5 8.4 16.3l39.2 28L84 372h29l8.1-12h147.8l8.1 12h29l-48.6-72zm31.6-49c0 8.3-6.7 15-15 15s-15-6.7-15-15 6.7-15 15-15 15 6.7 15 15zM202.5 66.5c0-4.6 3.9-8.3 8.5-8 21.5 1.3 39.2 4.9 50.4 7.8 3.1.8 5.5 3.4 5.9 6.6l3.8 25.6c.4 2.8-2.1 5.1-4.9 4.5-15.6-3.8-34.9-7.2-56.1-8.4-4.3-.2-7.6-3.7-7.6-8V66.5zM237.9 314h-85.7l9.4-14h66.8l9.5 14zM214 127c0 10.5-8.5 19-19 19s-19-8.5-19-19 8.5-19 19-19 19 8.5 19 19zm-98 139c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15zm7.8-163.1c-2.8.7-5.3-1.7-4.9-4.5l3.8-25.6c.5-3.2 2.8-5.8 5.9-6.6 11.2-2.9 28.8-6.5 50.4-7.7 4.6-.3 8.5 3.4 8.5 8v20c0 4.3-3.3 7.8-7.6 8-21.2 1.1-40.5 4.6-56.1 8.4zm8.1 241.1l9.4-14h107.3l9.4 14H131.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 29,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 29,
    r: 8
  }));
};

export default SvgWes;
//# sourceMappingURL=Wes.js.map